export function viewMoreFunction() {
    const parentSection = $(".view-more-holder");
    const moreBtn = parentSection.find(".view-more-button");

    if (parentSection.children().length <= 2) {
        moreBtn.css("display", "none");
    }

    moreBtn.on("click", function (e) {
        e.preventDefault();

        const moreHolder = $(this).closest(".view-more-holder");
        moreHolder.toggleClass("show");
    });

    $(window).on("load resize", function() {
        if($(window).width() > 767) {
            $(".view-more-holder").removeClass("show");
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/viewMoreFunction.js